<template>
    <div class="search-store">
        <store-item></store-item>
    </div>
</template>
<script>
    import storeItem from './Common/StoreItem.vue'

    export default {
        components: {
            'store-item': storeItem
        }
    }
</script>
<style></style>



// WEBPACK FOOTER //
// Store.vue?6e06cb1c